// What each kind of block draws (see ../protocol.js for what each may hold)
import PostWidget from './PostWidget'
import PostsWidget from './PostsWidget'
import EmailWidget from './EmailWidget'
import TextWidget from './TextWidget'
import BrandWidget from './BrandWidget'
import { LinksWidget, GuideWidget } from './LinksWidget'
import ChoicesWidget from './ChoicesWidget'
import PlansWidget from './PlansWidget'

export const WIDGETS = {
  post: PostWidget,
  posts: PostsWidget,
  email: EmailWidget,
  text: TextWidget,
  brand: BrandWidget,
  links: LinksWidget,
  guide: GuideWidget,
  choices: ChoicesWidget,
  plans: PlansWidget,
  // The server's pick, built: the same card, opened on that option
  playbook: PlansWidget,
}
